import { render, staticRenderFns } from "./trainTest.vue?vue&type=template&id=32856712&scoped=true"
import script from "./trainTest.vue?vue&type=script&lang=js"
export * from "./trainTest.vue?vue&type=script&lang=js"
import style0 from "./trainTest.vue?vue&type=style&index=0&id=32856712&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.11_cache-loader@4.1.0_webpack@4.47.0__css-load_e869bb83501a535456d8ad6b2e6cd142/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32856712",
  null
  
)

export default component.exports